import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";

const SessionExpiryModal = ({ open, onStaySignedIn, onLogout, onNotNow, timeRemaining }) => {
  const [isLoading, setIsLoading] = useState(false);

  // Reset loading state when modal opens/closes
  useEffect(() => {
    if (!open) {
      setIsLoading(false);
    }
  }, [open]);

  const handleStaySignedIn = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      await onStaySignedIn();
    } finally {
      setIsLoading(false);
    }
  };

  const formatTime = (ms) => {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? "s" : ""} ${seconds} second${seconds !== 1 ? "s" : ""}`;
    }
    return `${seconds} second${seconds !== 1 ? "s" : ""}`;
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onNotNow();
      }}
      aria-labelledby="session-expiry-dialog-title"
      aria-describedby="session-expiry-dialog-description"
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="session-expiry-dialog-title">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <WarningIcon color="warning" style={{ fontSize: "28px" }} />
            <span>Your session is about to expire</span>
          </div>
          <IconButton aria-label="close" onClick={onNotNow} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="session-expiry-dialog-description">
          For your security, your session will expire in{" "}
          {timeRemaining > 0 ? formatTime(timeRemaining) : "a few moments"}. Would you like to stay
          signed in?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleStaySignedIn}
          color="primary"
          variant="contained"
          autoFocus
          disabled={isLoading}
        >
          {isLoading ? "Please wait..." : "Stay Signed In"}
        </Button>
        <Button onClick={onLogout} color="secondary">
          Log Out
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiryModal;
